import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';

import {StatusData} from '../model/status-data';

@Injectable()
export class StatusRepository {

  constructor(private http: HttpClient, private authRequest: AuthRequest) { }

  public getStatusData(): Observable<StatusData> {
    return this.authRequest.handleRequest(
      this.http.get<StatusData>(environment.status.stateRoute, { withCredentials: true }));
  }
}
